<template>
    <el-dialog class="goods-info-operate-dialog" :title="title" width="40%" :modal-append-to-body="false" :visible.sync="visible" :close-on-click-modal="false" :before-close="handleClose">
        <el-form v-if="visible" inline ref="form" :model="form" :rules="rules" label-width="130px" size="mini" style="font-size: 14px;">
            <el-form-item label="业务类型" prop="businessType" >
                <el-select v-model="form.businessType">
                    <el-option
                        v-for="(item,index) in typeOptions"
                        :key="index"
                        :label="item.label"
                        :value="item.value"
                        v-show="showBusinessTypeOption(item.value)"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="项目名称" prop="productName">
                <el-input v-model="form.productName" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="税收分类编码" prop="taxCode">
                <el-input
                style="width: 160px;"
                v-model="form.taxCode"
                placeholder="请选择"
                @focus='$event.target.blur()'
                @click="showTaxCode"
                clearable>
                <el-button
                    slot="append"
                    icon="el-icon-search"
                    size="mini"
                    style="position: relative; left: 5px;"
                    @click="showTaxCode"
                ></el-button>
            </el-input>
            </el-form-item>
            <el-form-item label="税收分类名称" prop="taxName">
                <el-input v-model="form.taxName" placeholder="请输入" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="是否享受优惠政策" prop="isEnjoy">
                <el-select v-model="form.isEnjoy">
                    <el-option
                        label="是"
                        :value="1"
                    ></el-option>
                    <el-option
                        label="否"
                        :value="0"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="优惠政策类型" prop="preferentialPolicyType" >
                <el-select v-model="form.preferentialPolicyType" :disabled="prePolTypeDisabled">
                    <el-option
                        v-for="(item,index) in preferentialPolicyTypeOptions"
                        :key="index"
                        :label="item.label"
                        :value="item.value"
                    ></el-option>
                </el-select>
            </el-form-item>
            <!-- <el-form-item label="增值税特殊管理标识" prop="specialManagementOfVat">
                <el-input v-model="form.specialManagementOfVat" placeholder="请输入" :disabled="true"></el-input>
            </el-form-item> -->
            <el-form-item label="税率（%）" prop="taxRate">
                <el-select v-model="form.taxRate">
                    <el-option
                        v-for="(item,index) in taxRateOptions"
                        :key="index"
                        :label="item.label"
                        :value="item.value"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-dialog
                title="请选择优惠政策类型和税率"
                :visible.sync="dialogVisible"
                custom-class="policyAndSlDialog"
                width="25%"
                :modal="false"
                :append-to-body="true"
                :modal-append-to-body="false"
                :close-on-click-modal="false"
                :before-close="()=>setDialogVisible(false)">
                <div v-if="dialogVisible">
                    <el-form-item label="优惠政策类型" prop="preferentialPolicyType">
                        <el-select v-model="form.preferentialPolicyType" >
                            <el-option
                                v-for="(item,index) in preferentialPolicyTypeOptions"
                                :key="index"
                                :label="item.label"
                                :value="item.value"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="税率" prop="taxRate">
                        <el-select v-model="form.taxRate" >
                            <el-option
                                v-for="(item,index) in taxRateOptions"
                                :key="index"
                                :label="item.label"
                                :value="item.value"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="setDialogVisible(false)">取 消</el-button>
                    <el-button type="primary" @click="dialogConfirm">确 定</el-button>
                </span>
            </el-dialog>
            <el-dialog
                :visible.sync="isEnjoyPolicyDialogVisible"
                width="260px"
                custom-class="isEnjoyPolicyDialog"
                :append-to-body="true"
                :modal-append-to-body="false"
                :close-on-click-modal="false"
                :close-on-press-escape="false"
                center
                :showClose="false"
                >
                <span class="info">请问是否享受税收优化政策？</span>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="noEnjoyPolicyFn">否</el-button>
                    <el-button type="primary" @click="yesEnjoyPolicyFn">是</el-button>
                </span>
            </el-dialog>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose">取 消</el-button>
            <el-button type="primary" :loading="loading" @click="handleConfirm">保 存</el-button>
        </span>
        <TaxClassCodeTreeDialog v-if="visible" @confirmDialog="handleConfirmTaxCodeDialog" ref="raxClassCodeTreeDialog" />
    </el-dialog>
</template>

<script>
import { getDictAndOptions } from '@/modules/transport/bms/api/common.js';
import { saveProductInfo } from '@/modules/transport/bms/api/invoiceRegistrationApi.js';
import { stAi } from '@/modules/transport/bms/components/judge/bmsModular';
import TaxClassCodeTreeDialog from './TaxClassCodeTreeDialog.vue';
export default {
    name: 'goods-info-operate-dialog',
    components: { TaxClassCodeTreeDialog },
    data() {
        return {
            isEnjoyPolicyDialogVisible: false,
            dialogVisible: false,
            listData: [],

            typeOptions: [],
            preferentialPolicyTypeOptions: [],
            taxRateOptions: [],
            isEnjoyOptions: [],

            rules: {
                businessType: [{ required: true, message: '请选择业务类型', trigger: ['change'] }],
                productName: [{ required: true, message: '请输入项目名称', trigger: ['blur'] }],
                taxCode: [{ required: true, message: '请选择税收分类编码', trigger: ['change'] }],
                taxName: [{ required: true, message: '请选择税收分类名称', trigger: ['blur'] }],
                isEnjoy: [{ required: true, message: '请选择是否享受优惠政策', trigger: ['change'] }],
                specialManagementOfVat: [{ required: false, message: '请输入增值税特殊管理标识', trigger: ['blur'] }],
                taxRate: [{ required: true, message: '请选择优惠税率', trigger: ['change'] }],
                preferentialPolicyType: [{ required: true, message: '请选择优惠政策类型', trigger: ['change'] }]
            },
            form: {
                jobId: '',
                sourceJobId: '',
                businessType: '',
                productName: '',
                taxCode: '',
                taxName: '',
                isEnjoy: '',
                taxRate: '',
                preferentialPolicyType: '',
                specialManagementOfVat: ''
            },
            title: '新增',
            visible: false,
            loading: false
        };
    },
    computed: {
        showYhzcType: function() {
            return this.form.isEnjoy === 1;
        },
        prePolTypeDisabled: function() {
            return this.form.isEnjoy === 0;
        }
    },
    watch: {
        'form.isEnjoy': {
            immediate: true,
            handler: function (val) {
                !val && (this.form.preferentialPolicyType = '');
                this.rules.preferentialPolicyType[0].required = (!!val && val !== '0');
            }
        }
    },
    methods: {
        handleClose() {
            this.visible = false;
            this.clear();
        },
        handleVisible(flag, data, listData) {
            this.title = data.jobId ? '编辑' : '新增';
            Object.assign(this.$data.form, this.$options.data().form);
            this.visible = !!flag;
            this.form = stAi(data, this.form);
            this.listData = listData;
        },
        handleVerify(callback) {
            const checkFn = () => {
                let flag = true;
                const { businessType, taxRate, jobId } = this.form;
                if (!jobId && this.listData.some((el) => el.businessType === businessType && el.taxRate === taxRate)) {
                    this.$message.warning('已存在该税率和业务类型的项目信息，请勿重复维护!');
                    flag = false;
                }
                return flag;
            };
            this.$refs['form'].validate((valid) => {
                if (valid && checkFn()) {
                    callback();
                }
            });
        },
        handleConfirm() {
            this.handleVerify(() => {
                const params = {
                    ...this.form
                };
                this.loading = true;
                saveProductInfo(params).then(res => {
                    this.loading = false;
                    if (res && +res.code === 0) {
                        this.$message.success('保存成功');
                        this.$emit('addSuccess');
                        this.handleClose();
                    }
                }).catch(e => { this.loading = false; });
            });
        },
        setDialogVisible(flag) {
            if (flag) {
                this.form.taxRate = null;
                this.form.preferentialPolicyType = null;
            }
            this.dialogVisible = flag;
        },
        showTaxCode() {
            this.$refs.raxClassCodeTreeDialog.openDialog(true, this.form.taxCode);
        },
        handleConfirmTaxCodeDialog(data) {
            const { taxCode, taxName, specialManagementOfVat, taxShortName } = data;
            this.form.taxCode = taxCode;
            this.form.taxName = taxName;
            this.form.taxShortName = taxShortName;
            this.form.specialManagementOfVat = specialManagementOfVat;
            this.form.taxCode !== '' && (this.isEnjoyPolicyDialogVisible = true);
            this.$refs.raxClassCodeTreeDialog.openDialog(false);
        },
        clear() {
            this.$refs['form'].clearValidate();
            this.$refs['form'].resetFields();
        },

        dialogConfirm() {
            const fieldArr = ['preferentialPolicyType', 'taxRate'];
            const onSuccess = () => {
                this.setDialogVisible(false);
                this.isEnjoyPolicyDialogVisible = false;
            };
            const isEmptyVal = fieldArr.some(field => !this.form[field]);
            fieldArr.map(field => {
                this.$refs.form.validateField(field, (errorMessage) => {
                    if (!isEmptyVal) {
                        onSuccess();
                    } else {
                        return false;
                    }
                });
            });
            this.setFormData('isEnjoy', 1);
        },
        noEnjoyPolicyFn() {
            this.setFormData('isEnjoy', 0);
            this.isEnjoyPolicyDialogVisible = false;
            this.rules.preferentialPolicyType[0].required = false;
            this.form.preferentialPolicyType = '';
        },
        yesEnjoyPolicyFn() {
            this.rules.preferentialPolicyType[0].required = true;
            this.form.preferentialPolicyType = '';
            this.setDialogVisible(true);
        },
        setFormData(key, val) {
            Object.hasOwnProperty.call(this.form, key) ? this.form[key] = val : this.$set(this.form, key, val);
        },
        showBusinessTypeOption(val) {
            return [1, 10, 4, 2, 5, 3].includes(+val);
        }
    },
    async created() {
        const { SYS_BMS_BUSI_TYPE_OPTIONS, SYS_BMS_EIS_TAX_RATE_OPTIONS, SYS_BMS_EIS_TAX_PREF_POLICY_TYPE_OPTIONS } =
        await getDictAndOptions('SYS_BMS_EIS_TAX_RATE,SYS_BMS_EIS_TAX_PREF_POLICY_TYPE,SYS_BMS_BUSI_TYPE');
        this.typeOptions = SYS_BMS_BUSI_TYPE_OPTIONS;
        this.taxRateOptions = SYS_BMS_EIS_TAX_RATE_OPTIONS;
        this.preferentialPolicyTypeOptions = SYS_BMS_EIS_TAX_PREF_POLICY_TYPE_OPTIONS;
    }
};
</script>
<style lang="less">
.goods-info-operate-dialog {

    .dialog-region-select {
        input {
            width: 100%;
            margin-right: 32px;
        }
        .el-input__suffix {
            right: 35px;
        }
    }
    .nobottom-form-item {
        margin-bottom: 0;
    }
    .el-select{
        width: 160px !important;
    }
}
.isEnjoyPolicyDialog{
    .el-dialog__header{
        display: none;
    }
    .el-dialog__body{
        text-align: center;
        padding-bottom: 15px;
        .info{
            font-size: 14px;
        }
    }
}
.policyAndSlDialog{
    .el-form-item__error{
        left: 28%;
    }
}
.el-form-item.is-success .el-input__inner{
    border-color:#00BCBF !important;
}
</style>
